<template>
    <div class="project-group-card">
        <div class="project-group-card__header">
            <NuxtLink :to="projectGroupLink" class="h4-t project-group-card__title">
                {{ project.name }}
            </NuxtLink>
            <div class="project-group-card__control">
                <UiMenu icon="edit">
                    <!-- <UiMenuItem icon="edit-i" text="Редактировать" @click.stop="emit('project-edit', project.id)" /> -->
                    <UiMenuItem icon="trash" text="Удалить" @click.stop="emit('project-delete', project.id)" />
                </UiMenu>
            </div>
        </div>
        <div class="project-group-card__dynamics">
            <MonitoringDynamicsItem v-for="(d_item, index) in topWords"
                                    :key="index"
                                    :data="d_item"
                                    class="project-group-card__dynamics-item _default"
            />
            <MonitoringDynamicsItemCircle :data="processedWords" class="project-group-card__dynamics-item _circle" />
            <MonitoringDynamicsItemColumn :data="bestPosition" class="project-group-card__dynamics-item _column" />
        </div>
        <div class="project-group-card__button">
            <NuxtLink :to="projectGroupLink" class="project-group-card__link">
                <span>Перейти к проекту</span>
                <WBIcon name="chevron-right" />
            </NuxtLink>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ProjectGroupDto } from '~/src/shared/types/generated.ts'
    import MonitoringDynamicsItem from '~/src/shared/components/pages/monitoring/MonitoringDynamicsItem/MonitoringDynamicsItem.vue'
    import MonitoringDynamicsItemCircle from '~/src/shared/components/pages/monitoring/MonitoringDynamicsItem/MonitoringDynamicsItemCircle.vue'

    import MonitoringDynamicsItemColumn from '~/src/shared/components/pages/monitoring/MonitoringDynamicsItem/MonitoringDynamicsItemColumn.vue'

    const props = defineProps<{
        project: ProjectGroupDto
    }>()

    const emit = defineEmits<{
        'project-edit': [id: number]
        'project-delete': [id: number]
    }>()

    const projectGroupLink = computed(() => `/monitoring/${props.project.id}`)
    const projectsList = computed(() => props.project.projects)
    const firstProjectOfGroup = computed(() => projectsList.value?.[0])
    const dynamicsData = computed(() => firstProjectOfGroup.value?.monitoringProject)
    const topWords = computed(() => {
        return [
            {
                name: 'Слов в топ 1',
                value: dynamicsData.value?.d0Top1,
                changes: dynamicsData.value?.changeTop1
            },
            {
                name: 'Слов в топ 4',
                value: dynamicsData.value?.d0Top4,
                changes: dynamicsData.value?.changeTop4,
            },
            {
                name: 'Cлов в топ 12',
                value: dynamicsData.value?.d0Top12,
                changes: dynamicsData.value?.changeTop12,
            },
            {
                name: 'Cлов в топ 100',
                value: dynamicsData.value?.d0Top100,
                changes: dynamicsData.value?.changeTop100,
            }
        ]
    })

    const processedWords = computed(() => ({
        totalWords: dynamicsData.value?.wordCount,
        processedWords: dynamicsData.value?.d0Total,
    }))

    const bestPosition = computed(() => ({
        value: dynamicsData.value?.d0AvgPos,
        changes: dynamicsData.value?.changeAvgPos
    }))
</script>

<style lang="scss" scoped>
    .project-group-card {
        padding: 24px 24px 20px;
        border-radius: 20px;
        background-color: var(--white);

        @include respond-to(mobile) {
            padding: 16px 16px 12px;
        }

        &__header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            margin-bottom: 24px;

            @include respond-to(mobile) {
                margin-bottom: 16px;
            }
        }

        &__title {
            position: relative;
            color: var(--black-color-lighter);
            transition: color $default-transition;

            @include hover {
                color: var(--blue-500);
            }
        }

        &__dynamics {
            display: flex;
            gap: 12px;
            flex-flow: row nowrap;

            @include respond-to(tablet) {
                flex-flow: row wrap;
            }

            @include respond-to(mobile) {
                gap: 8px;
            }

            &-item {
                flex: 1 1 auto;
                border-radius: 8px;
                border: 1px solid var(--grey-200);

                &._default {
                    width: 12.5%;

                    @include respond-to(tablet) {
                        width: calc(50% - 6px);
                    }
                }

                &._circle {
                    width: 25%;

                    @include respond-to(tablet) {
                        width: calc(50% - 6px);
                    }

                    @include respond-to(mobile) {
                        width: 100%;
                    }
                }

                &._column {
                    width: 25%;

                    @include respond-to(tablet) {
                        width: calc(50% - 6px);
                    }

                    @include respond-to(mobile) {
                        width: 100%;
                    }
                }
            }
        }

        &__button {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 20px;

            @include respond-to(mobile) {
                margin-top: 12px;
            }
        }

        &__link {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: 600;
            color: var(--blue-600);
            gap: 0 13px;
        }

        &__control {
            position: relative;

            &-button {
                width: 24px;
                height: 24px;
                border-radius: 4px;
                transition: color $default-transition, background-color $default-transition;
                cursor: pointer;

                @include hover {
                    background-color: var(--blue-50);
                    color: var(--blue-600);
                }

                &._active {
                    background-color: var(--blue-50);
                    color: var(--blue-600);
                }
            }

            &-menu {
                position: absolute;
                top: 24px;
                right: calc(100%);
                width: 200px;
                height: 132px;
            }
        }
    }
</style>
